import { render } from "./EditUserDetails.vue?vue&type=template&id=089589d4&scoped=true"
import script from "./EditUserDetails.vue?vue&type=script&lang=js"
export * from "./EditUserDetails.vue?vue&type=script&lang=js"

import "./EditUserDetails.vue?vue&type=style&index=0&id=089589d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089589d4"]])

export default __exports__